import { productSlider } from "@omni/ui/brand/product/productSlider/productSlider.styles";

import { useProductSliderContext } from "@/components/Product/ProductSlider/context/productSlider.context";

type Props = {
    className?: string;
};

export const Base = ({ className }: Props) => {
    const { title } = useProductSliderContext();

    if (!title) return null;

    const { header_title } = productSlider();

    return <h2 className={header_title({ className })}>{title}</h2>;
};
